<template>
  <div v-if="dataInteractiveModal">
    <Quiz v-if="dataInteractiveModal.type === 'quiz'" :data="dataInteractiveModal" :closeModal="closeModal" :player="player" />
    <Sondage v-if="dataInteractiveModal.type === 'sondage'" :data="dataInteractiveModal" :closeModal="closeModal" :player="player"/>
    <Question v-if="dataInteractiveModal.type === 'question'" :data="dataInteractiveModal" :closeModal="closeModal" :player="player"/>
  </div>
</template>

<script >
import { defineComponent } from "vue";
import Quiz from "./InteractiveQuiz.vue";
import Sondage from "./InteractiveSondage.vue";
import Question from "./InteractiveQuestion.vue";

export default defineComponent({
  name: "interacitive-modal",
  components: {
    Question,
    Sondage,
    Quiz,
  },
  props: {
    dataInteractiveModal: {
      required: true,
      type: Object,
    },
    closeModal: {
      type: Function,
    },
    player:{
      required: true,
      type: Object,
    }
  },

  data() {
    return {
      items: [],
      itemToDisplay: {},
    };
  },
});
</script>

<style scoped></style>
